import { RECEIVE_CAROUSEL_DATA } from "../actions/carouseActions";

const initialState = {};

export default function carouselReducer(state = initialState, action) {
  switch (action.type) {
    case RECEIVE_CAROUSEL_DATA:
      return {
        ...state,
        carousel: [...action.payload]
      };
    default:
      return state
  }
};



// WEBPACK FOOTER //
// ./src/reducers/carouselReducer.js